/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var setProp = require('./setProp')

module.exports =
  setProp.origFn('assoc')
